import { InputAdornment } from '@mui/material';
import React from 'react';
import { Poppins } from 'src/common';
import MaterialInput from 'src/components/form/MaterialInput';
import styled from 'styled-components';
import { getCurrencySymbol } from 'src/utils/misc';
import { StyleProps } from './types';

export const SymbolAdornment = styled(Poppins)`
  margin-bottom: 1px;
`;

// `currency`/`currencyPx` only drive `.attrs` and the CSS below — the global
// StyleSheetManager filter skips styled(Component) targets, so without this they
// would flow through MaterialInput onto the DOM (React unknown-attribute warning).
export const MaterialInputCustom = styled(MaterialInput)
  .withConfig({ shouldForwardProp: (prop) => prop !== 'currency' && prop !== 'currencyPx' })
  .attrs<StyleProps>(({ currency, currencyPx = 16, ...p }) => {
  return {
    fullWidth: true,
    InputProps: currency
      ? {
          startAdornment: React.createElement(
            InputAdornment,
            { position: 'start' },
            React.createElement(
              SymbolAdornment,
              { px: currencyPx, weight: 500, color: 'cflowerBlue' },
              getCurrencySymbol(),
            ),
          ),
        }
      : undefined,
    ...p,
  };
})<StyleProps>`
  .MuiInputBase-root {
    background-color: ${({ theme }) => theme.colors.cultured};
  }

  & .MuiInputBase-root {
    padding-left: 10px;
  }

  input {
    padding-left: ${({ currency }) => (currency ? 0 : 8)}px !important;
    padding-right: 6px !important;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      display: none;
    }
  }

  .MuiFormHelperText-root {
    bottom: -20px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    input {
      padding-left: ${({ currency }) => (currency ? 0 : 20)}px;
    }
  }
`;

export const Symbol = styled(Poppins).attrs((p) => {
  return { px: 16, ...p };
})`
  color: ${({ theme }) => theme.colors.cflowerBlue};
  font-weight: 500;
`;
